import React from 'react';
import './homegallery.css';

const NewsGrid = () => {
  const news = [
  {
    title: "Thanks to all Stakeholders | Khadija Welfare Trust",
    description: "",
    videoId: "VlNfqruPMHg", // replace with your own video ID
    
  },
  {
    title: "Winter Relief To Homeless | Khadija Welfare Trust",
    description: "",
    videoId: "RQUVwjCLK_M",
   
  },
  {
    title: "Qurbani Meat Has Successfully Reached Jordan | Khadija Welfare Trust",
    description: "",
    videoId: "8amxAf8vUkE",
   
  }
];

  return (
    <div className="news-container">
      <h1 style={{textAlign:"center"}} className="news-title">Latest Updates</h1>
      <div className="news-grid">
        {news.map((item, index) => (
          <div key={index} className="news-item">
            <div className="video-wrapper">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${item.videoId}`}
                title={item.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h3 className="news-item-title">{item.title}</h3>
            <p className="news-item-description">{item.description}</p>
            <a href={item.link} className="news-item-link">Read more</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsGrid;
